import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import * as ROUTES from '../constants/routes';
import { DASHBOARD_SECTIONS } from '../constants/dashboardSections';
import RequireAuth from './RequireAuth';
import LoginScreen from '../screen/LoginScreen';
import DashboardScreen from '../screen/DashboardScreen';
import OverviewScreen from '../screen/OverviewScreen';
import LogoutScreen from '../screen/LogoutScreen';
import ForgotPasswordScreen from '../screen/ForgotPasswordScreen';
import ResetPasswordScreen from '../screen/ResetPasswordScreen';
import CustomerDetailsScreen from '../screen/CustomerDetailsScreen';
import OrderDetailScreen from '../screen/OrderDetailsScreen';
import UserDetailsScreen from '../screen/UserDetailsScreen';

const AuthRoutes = () => {
    return (
        <Routes>
            {/* Public */}
            <Route path={ROUTES.HOME} element={<LoginScreen />} />
            <Route path={ROUTES.LOGIN} element={<LoginScreen />} />
            <Route path={ROUTES.LOGOUT} element={<LogoutScreen />} />
            <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordScreen />} />
            <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordScreen />} />

            {/* Signed-in area */}
            <Route element={<RequireAuth />}>
                {/* Entry point: redirects to the first section the user may see */}
                <Route path={ROUTES.DASHBOARD} element={<DashboardScreen />} />

                {/* One route per dashboard section, inside the shared shell */}
                <Route element={<DashboardScreen />}>
                    {DASHBOARD_SECTIONS.map((section) => (
                        <Route
                            key={section.key}
                            path={section.path}
                            element={section.children}
                        />
                    ))}
                </Route>

                {/* Detail screens — the identifier lives in the URL */}
                <Route path={ROUTES.CABINET_DETAILS} element={<OverviewScreen />} />
                <Route path={ROUTES.CUSTOMER_DETAILS} element={<CustomerDetailsScreen />} />
                <Route path={ROUTES.ORDER_DETAILS} element={<OrderDetailScreen />} />
                <Route path={ROUTES.USER_DETAILS} element={<UserDetailsScreen />} />
            </Route>

            <Route path='*' element={<Navigate to={ROUTES.HOME} replace={true} />} />
        </Routes>
    );
};

export default AuthRoutes;
